import { CssBaseline } from '@mui/material';

import { AppRoutes, useLogin } from './routes/AppRoutes';
import { LanguageProvider } from 'dg-web-shared/lib/Localization';
import { ParkingaboThemeProvider } from './shared/ParkingaboThemeProvider';
import { envIsLocalDev } from 'dg-web-shared/lib/Environment.ts';
import { useSystemLanguage } from 'dg-web-shared/lib/useSystemLanguage.ts';
import { useEffect } from 'react';

export function App() {
    const { language, setLanguage } = useSystemLanguage();
    const login = useLogin();

    useEffect(() => {
        if (envIsLocalDev()) {
            document.title = 'LOCAL Parkingabo';
        }
    }, []);

    return (
        <LanguageProvider context={{ language, setLanguage }}>
            <ParkingaboThemeProvider language={language}>
                <CssBaseline />
                <AppRoutes login={login} />
            </ParkingaboThemeProvider>
        </LanguageProvider>
    );
}
